.dot {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}

.atencao {
  fill: var(--warn-mark);
}

.positivo {
  fill: var(--pos-mark);
}

.negativo {
  fill: var(--neg-mark);
}

.outros {
  fill: var(--other-mark);
}

.neutro {
  fill: var(--mark-gray);
}

.age {
  fill: var(--ink);
}

.ring {
  fill: none;
  stroke: var(--label-3);
  stroke-width: 1.6;
  stroke-dasharray: 1.25 0.75;
}
